// Client redirect links shown to the PM (DashboardDetails "links" section,
// which the redesigned OverviewPane reuses). The survey provider sends the
// respondent's browser to one of these when the survey ends.
//
//   dynamic  <base>/#/surveys/<slug>?surveyid=<uniqueid>&userid={userid}
//            -> SurveyCallbackPage (records against this survey)
//   static   <base>/#/<slug>?userid={userid}
//            -> SurveyThankYouPage (records against the respondent's latest open entry)
//
// {userid} is left as a literal placeholder for the provider to replace.
// public/dummy-survey*.html redirect to these same formats.

export type CallbackSlug = 'completed' | 'overquota' | 'terminate' | 'qualityterminate';

export const CALLBACK_LINK_ROWS: ReadonlyArray<readonly [string, CallbackSlug]> = [
    ['Complete URL', 'completed'],
    ['Over Quota URL', 'overquota'],
    ['Terminate URL', 'terminate'],
    ['Quality Terminate URL', 'qualityterminate'],
];

export const dynamicCallbackUrl = (base: string, surveyUniqueId: unknown, slug: CallbackSlug): string =>
    `${base}/#/surveys/${slug}?surveyid=${surveyUniqueId}&userid={userid}`;

export const staticCallbackUrl = (base: string, slug: CallbackSlug): string =>
    `${base}/#/${slug}?userid={userid}`;
